import { render, staticRenderFns } from "./SensRederer.vue?vue&type=template&id=0d97ea80&"
import script from "./SensRederer.vue?vue&type=script&lang=ts&"
export * from "./SensRederer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports